module.exports = __webpack_public_path__ + "img/static-main.716d4d02.png";